
export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const timeOptions = [
  "12:00 AM",
  "1:00 AM",
  "2:00 AM",
  "3:00 AM",
  "4:00 AM",
  "5:00 AM",
  "6:00 AM",
  "7:00 AM",
  "8:00 AM",
  "9:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "1:00 PM",
  "2:00 PM",
  "3:00 PM",
  "4:00 PM",
  "5:00 PM",
  "6:00 PM",
  "7:00 PM",
  "8:00 PM",
  "9:00 PM",
  "10:00 PM",
  "11:00 PM",
];

// Utility functions for date and time handling

// Convert time string to hour number
export const timeStringToHour = (timeStr: string): number => {
  const [time, period] = timeStr.split(" ");
  let hour = parseInt(time);
  if (period === "PM" && hour !== 12) hour += 12;
  if (period === "AM" && hour === 12) hour = 0;
  return hour;
};

// Convert hour number to time string
export const hourToTimeString = (hour: number): string => {
  if (hour === 0) return "12:00 AM";
  if (hour === 12) return "12:00 PM";
  if (hour < 12) return `${hour}:00 AM`;
  return `${hour - 12}:00 PM`;
};

// Generate calendar days for a given month (dynamically shows exactly one full line of gray dates from next month at bottom to complete the row, no previous month dates at top)
export const generateCalendarDays = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0); // Last day of the month
  
  // Start from the first day of the current month (no previous month dates)
  const startDate = new Date(firstDay);

  const days = [];
  const current = new Date(startDate);

  // Generate all days of current month
  while (current <= lastDay) {
    days.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  // Dynamically calculate how many gray dates needed to complete exactly one full line (7 days)
  const currentMonthDaysCount = days.length;
  const remainder = currentMonthDaysCount % 7;
  // If remainder is 0, add 7 gray dates (one full line). Otherwise, add enough to complete the line.
  const grayDatesCount = remainder === 0 ? 7 : (7 - remainder);
  
  const nextMonthFirstDay = new Date(year, month + 1, 1);
  for (let i = 0; i < grayDatesCount; i++) {
    const nextMonthDate = new Date(nextMonthFirstDay);
    nextMonthDate.setDate(nextMonthFirstDay.getDate() + i);
    days.push(nextMonthDate);
  }

  return days;
};

// Check if a date is in the current month
export const isCurrentMonth = (date: Date, monthDate: Date) => {
  return (
    date.getMonth() === monthDate.getMonth() &&
    date.getFullYear() === monthDate.getFullYear()
  );
};

// Format date for display
export const formatDate = (date: Date | null, time: string, monthsArray: string[]) => {
  if (!date) return "";
  const day = date.getDate();
  const month = monthsArray[date.getMonth()].slice(0, 3);
  const year = date.getFullYear();
  return `${day} ${month} ${year} ${time}`;
};

// Format date for mobile (shorter)
export const formatDateMobile = (date: Date | null, time: string, monthsArray: string[]) => {
  if (!date) return "";
  const day = date.getDate();
  const month = monthsArray[date.getMonth()].slice(0, 3);
  return `${day} ${month} ${time}`;
};
export const formatDateFromApi = (dateString: string) => {
  return new Date(dateString).toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
